export const DEFAULT_PAGINATION_MODEL = {
  page: 0,
  pageSize: 25,
};

export const HISTORY_STATUS_CONFIG = {
  Edit: { label: 'Modifié', cssClass: 'badgeModifie' },
  Delete: { label: 'Supprimé', cssClass: 'badgeSupprime' },
  Restore: { label: 'Restauré', cssClass: 'badgeRestaure' },
  Added: { label: 'Ajouté', cssClass: 'badgeAjoute' },
};

export const formatDate = (timeUnix) =>
  timeUnix
    ? new Date(timeUnix * 1000).toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    : '—';

export const parseDatetimeLocalToUnix = (value) => {
  if (!value) return null;
  const ts = Math.floor(new Date(value).getTime() / 1000);
  return Number.isFinite(ts) ? ts : null;
};

export const getSensorLabel = (capteur, capteurId) =>
  capteur?.sensor_name ?? capteur?.name ?? `Capteur ${capteurId}`;

export const normalizeSelectionModel = (model) => {
  if (Array.isArray(model)) return model;
  if (model && model.ids instanceof Set) return Array.from(model.ids);
  return [];
};

export const normalizeHistoryResponse = (res) => {
  const raw = res?.data?.history ?? res?.data?.data ?? res?.data ?? res ?? [];
  return Array.isArray(raw) ? raw : [];
};

export const toHistoryKey = (sensorId, pkTest) => `${sensorId}_${pkTest}`;

const toTs = (value) =>
  typeof value === 'number'
    ? value
    : Math.floor(new Date(value ?? 0).getTime() / 1000);

export const sortHistoryEntries = (entries) =>
  [...entries].sort(
    (a, b) => toTs(a.modification_date) - toTs(b.modification_date)
  );

export const buildHistoryMap = (entries) => {
  const map = {};

  entries.forEach((entry) => {
    const key = toHistoryKey(entry.sensor_id, entry.pk_test);
    if (!map[key]) map[key] = [];
    map[key].push(entry);
  });

  Object.keys(map).forEach((key) => {
    map[key] = sortHistoryEntries(map[key]);
  });

  return map;
};

export const mergeHistoryEntries = (currentEntries, incomingEntries) => {
  const merged = [...currentEntries, ...incomingEntries];
  const byKey = new Map();

  merged.forEach((entry) => {
    const key = `${entry.sensor_id}_${entry.pk_test}_${entry.modification_date}_${entry.update_type}_${entry.id ?? ''}`;
    if (!byKey.has(key)) {
      byKey.set(key, entry);
    }
  });

  return sortHistoryEntries(Array.from(byKey.values()));
};

export const mergeHistoryMaps = (currentMap, incomingMap) => {
  const next = { ...currentMap };

  Object.entries(incomingMap).forEach(([key, entries]) => {
    next[key] = mergeHistoryEntries(next[key] ?? [], entries);
  });

  return next;
};

export const getLatestHistoryEntry = (entries = []) =>
  entries.length > 0 ? entries[entries.length - 1] : null;

export const createRestoreHistoryEntry = (row, latestEntry) => ({
  id: Date.now(),
  user_id: latestEntry?.user_id ?? null,
  user_name: latestEntry?.user_name ?? 'Utilisateur courant',
  sensor_id: Number(row?._sensorId ?? row?.sensor_id),
  pk_test: row?.pk_test,
  position_in_sensor: row?.position_in_sensor,
  old_time_unix:
    latestEntry?.new_time_unix ?? row?.old_time_unix ?? row?.time_unix ?? null,
  new_time_unix: row?.time_unix ?? null,
  old_value: latestEntry?.new_value ?? row?.old_value ?? row?.value ?? null,
  new_value: row?.value ?? null,
  old_calc_value:
    latestEntry?.new_calc_value ??
    row?.old_calc_value ??
    row?.calc_value ??
    null,
  new_calc_value: row?.calc_value ?? null,
  update_type: 'Restore',
  modification_date: Math.floor(Date.now() / 1000),
});

export const normalizeRowsPayload = (raw) => {
  if (Array.isArray(raw)) return raw;

  return Object.entries(raw ?? {}).flatMap(([sensorIdKey, rowsBySensor]) =>
    Array.isArray(rowsBySensor)
      ? rowsBySensor.map((row) => ({
          ...row,
          sensor_id: row.sensor_id ?? Number(sensorIdKey),
        }))
      : []
  );
};

export const buildSensorsPositionsMap = (pairs) => {
  const sensorsPositions = {};

  pairs.forEach(({ sensorId, position }) => {
    const numericSensorId = Number(sensorId);
    const numericPosition = Number(position);

    if (!Array.isArray(sensorsPositions[numericSensorId])) {
      sensorsPositions[numericSensorId] = [];
    }

    if (!sensorsPositions[numericSensorId].includes(numericPosition)) {
      sensorsPositions[numericSensorId].push(numericPosition);
    }
  });

  return sensorsPositions;
};
